var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-container" }, [
    _c(
      "div",
      { staticClass: "filter-widget-content" },
      _vm._l(_vm.tabUseList, function (item, index) {
        var _obj
        return _c(
          "div",
          {
            key: index,
            class: [
              ((_obj = {}),
              (_obj["selected-class"] = _vm.selectedId == item.id),
              _obj),
              "filter-widget " + (item.defaultClass || ""),
            ],
            attrs: { "data-id": item.id, "data-index": index },
            on: {
              click: function ($event) {
                return _vm.componentSelect(item)
              },
            },
          },
          [
            _c("div", { staticClass: "filter-widget-icon" }, [
              _c("i", {
                class: (item.icon || "el-icon-setting") + " widget-icon-i",
              }),
            ]),
            _c("div", { staticClass: "filter-widget-text" }, [
              _vm._v(_vm._s(item.label)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }